import { Dialog, DialogActions, DialogContent, DialogTitle, Stack } from "@mui/material";
import Form from "components/form/Form";
import TextFieldControl from "components/form/TextFieldControl";
import { useForm } from "react-hook-form";
import { CreateCompetencyMapFromFileInput, useCreateCompetencyMapFromJsonMutation } from "@generated/graphql";
import VALIDATION from "helpers/validation";
import FileUploadButton from "components/buttons/FileUploadButton";
import Button from "@mui/material/Button";
import { LoadingButton } from "@mui/lab";
import { useContext } from "react";
import { ToastContext, ToastTypeEnum } from "context/toastContext";
import { useNavigate } from "react-router-dom";
import { parseApolloError } from "helpers/errorsParser";

interface UploadJSONModalProps {
  open: boolean;
  handleClose: () => void;
}

const UploadJSONModal = ({ open, handleClose }: UploadJSONModalProps) => {
  const navigate = useNavigate();
  const { addToast } = useContext(ToastContext);
  const form = useForm<CreateCompetencyMapFromFileInput>();
  const { handleSubmit } = form;

  const [createTemplate, { loading }] = useCreateCompetencyMapFromJsonMutation();

  const onError = () => addToast({ type: ToastTypeEnum.ERROR });

  const onSubmit = (formData: CreateCompetencyMapFromFileInput) => {
    createTemplate({
      variables: {
        input: {
          title: formData.title,
          specialization: formData.specialization,
          dataFile: formData.dataFile,
        },
      },
    })
      .then((res) => {
        const competencyMapId = res.data?.createCompetencyMapFromJson.id;
        if (competencyMapId) {
          navigate(`view/${competencyMapId}`);
          addToast({ type: ToastTypeEnum.SUCCESS });
          handleClose();
        } else onError();
      })
      .catch((e) => parseApolloError(e, { addToast }));
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth='sm'>
      <DialogTitle
        variant='h24'
        textAlign='center'>
        Загрузка карты компетенций
      </DialogTitle>
      <DialogContent>
        <Form form={form}>
          <Stack spacing={2}>
            <TextFieldControl
              label='Название карты компетенций'
              name='title'
              rules={{ required: true, ...VALIDATION.competencyMapTitle }}
            />
            <TextFieldControl
              label='Специализация'
              name='specialization'
              rules={{ required: true, ...VALIDATION.competencyMapTitle }}
            />
            <FileUploadButton
              name='dataFile'
              label='Загрузить карту'
              accept='application/JSON, .json'
              rules={{ required: "Обязательное поле" }}
            />
          </Stack>
        </Form>
      </DialogContent>
      <DialogActions>
        <Button
          variant='outlined'
          onClick={handleClose}>
          Отмена
        </Button>
        <LoadingButton
          onClick={handleSubmit(onSubmit, onError)}
          loading={loading}
          variant='contained'>
          Загрузить
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default UploadJSONModal;
